<template>
  <div class="flex w-full min-w-0 flex-1 items-center">
    <TransitionGroup name="list" tag="div" class="flex gap-2">
      <div
        v-for="filter in sortedFilters"
        :key="filter.key"
        @click="emits('toggleFilter', filter)"
        class="flex-shrink-0"
      >
        <div
          class="chip flex items-center rounded-lg bg-color-bg-secondary hover:bg-color-bg-secondary-hover"
          :class="{ active: filter.isActive }"
        >
          <div class="whitespace-nowrap text-sm">{{ filter.label }}</div>

          <img class="close-btn" :class="{ hide: !filter.isActive }" :src="CloseIcon.src" />
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import CloseIcon from "src/core-ui-vue/components/IAIIcon/icons/Close.svg";
import { QuickFilter } from "@/features/profile-shop/composables/useProfileShopFilters";

const props = defineProps({
  filters: { type: Array as PropType<Array<QuickFilter>>, default: () => [] },
});

const emits = defineEmits<{
  (e: "toggleFilter", filter: QuickFilter): void;
}>();

const sortedFilters = computed(() => [...props.filters].sort((a, b) => Number(b.isActive) - Number(a.isActive)));
</script>

<style scoped lang="scss">
.chip {
  transition: all 0.2s ease-in-out;
  padding: 10px 20px;

  &:hover {
    cursor: pointer;
  }

  &.active {
    background-color: var(--color-bg-secondary-active);
    gap: 8px;
    &:hover {
      background-color: var(--color-bg-secondary-active-hover);
    }
  }
}
.close-btn {
  width: 10px;
  height: 10px;
  opacity: 1;
  transform: scale(1);
  transition: all 0.2s ease-in-out;

  &.hide {
    opacity: 0;
    width: 0;
    height: 0;
    transform: scale(0.5);
    pointer-events: none;
  }
}

.list-move {
  transition: transform 0.4s ease-in-out;
}
.list-enter-active,
.list-leave-active {
  transition:
    opacity 0.3s,
    transform 0.4s;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
